import getValidationError from './getValidationError'

export default (field, value) => !(field.validation && getValidationError(field.validation, value))
